var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
let MenuPartTopicTitle = class MenuPartTopicTitle extends React.PureComponent {
    render() {
        const { topic } = this.props;
        if (!topic)
            return null;
        return (React.createElement("div", { "data-name": "MenuPartTopicTitle", style: { marginTop: 30, wordWrap: 'break-word', flex: '0 1 auto' } },
            React.createElement("h1", { style: {
                    color: '#555',
                    lineHeight: '110%',
                    fontSize: 18,
                    marginBottom: 10,
                    marginTop: 10,
                    marginLeft: 10,
                    marginRight: 10
                } }, topic.name)));
    }
};
MenuPartTopicTitle = __decorate([
    observer
], MenuPartTopicTitle);
export { MenuPartTopicTitle };
